import education1 from "../assets/png/education.jpg";
import coopertionImg from "../assets/png/cooperation.jpg";

export const educationData = {
  description1:
    "W moim życiu czerpałam z wiedzy wielu specjalistów, co miało istotny wpływ na moje zawodowe i osobiste ukształtowanie. Jako fizjoterapeuta od początku kariery jestem związana z gabinetem Fizjo-Factory, a także pracuję niezależnie. Moje doświadczenie trenerskie obejmuje liczne boxy CrossFit, gdzie prowadziłam zarówno zajęcia grupowe, jak i indywidualne, zdobywając bogate doświadczenie w dziedzinie treningów.",
  description2:
    "Obecnie pracuję jako trener indywidualny w ZdroFit. Prowadzę klientów przez proces diagnostyki, terapii manualnej oraz treningów, dostosowując je do indywidualnych potrzeb oraz grupowych celów.",
  cooperations: [
    "Mamy",
    "Osoby z nadwagą i otyłością",
    "Osoby z bólem ostrym i przewlekłym",
    "Osoby po operacjach",
    "Osoby z dyskopatią",
    "Seniorzy",
    "Kobiety w ciąży",
    "Pracownicy biurowi",
  ],
  cards: [
    {
      id: 1,
      institution: "",
      course: "Dry Needling (wg FRSc)",
      startYear: "",
      endYear: "",
    },
    {
      id: 2,
      institution: "",
      course: "Cykl kursów USG narządu ruchu (RSU)",
      startYear: "",
      endYear: "",
    },
    {
      id: 3,
      institution: "",
      course: "Masaż Tkanek Głębokich (NeuroProjekt)",
      startYear: "",
      endYear: "",
    },
    {
      id: 4,
      institution: "",
      course: "RTS po operacji ACL (Piotr Ciebiera)",
      startYear: "",
      endYear: "",
    },
    {
      id: 5,
      institution: "",
      course: "Rehabilitacja po operacjach stawu kolanowego (Jakub Materla)",
      startYear: "",
      endYear: "",
    },
    {
      id: 6,
      institution: "",
      course: "Kompleksowa fizjoterapia w uroginekologii (RehaIntegro)",
      startYear: "",
      endYear: "",
    },
    {
      id: 7,
      institution: "",
      course: "Manipulacje nerwowo-mięśniowe (Jakub Stępnik)",
      startYear: "",
      endYear: "",
    },
  ],
  image1: education1,
  imageCooperation: coopertionImg,
};
